import { defineStore } from 'pinia';
import ApiService from '@/services/ApiService';
import { useIdentityStore } from '@/store/IdentityStore';
import { storeToRefs } from 'pinia/dist/pinia';

export const useUserStore = defineStore('UserStore',{
    state: () => ({
        users:[],
        user: null
    }),
    getters:{
        firstName () {
            return this.user.name.split(' ')[0];
        },
        getUserN () {
            return '';
        },

    },
    actions: {
        async getAll () {
            this.users = { loading: true };
            ApiService.getUser()
                .then(users => this.users = users)
                .catch(error => this.users = { error });
        },
        getUser () {
        },
        setUser () {
            const identityStore = useIdentityStore();
            const { User } = storeToRefs(identityStore);
            this.user = User;
        },
        getRMTPermission () {
            return;
        }
        
    }
});